import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/cycle-calendars", params );
};

const getAllForCSV = params => {
  return restApi.post("/api/cycle-calendars/csv", params );
};

const get = name => {
  return restApi.get(`/api/cycle-calendar/${name}`);
};

const upsert = data => {
  return restApi.post("/api/cycle-calendar/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/cycle-calendars/${ids}`);
};

const cycleCalendarService = {
  getAll,
  getAllForCSV,
  get,
  upsert,
  remove
};

export default cycleCalendarService;